module.exports = __webpack_public_path__ + "img/icon-building-habits.3727cfcd.png";